<script>
import TopBar from '@components/top-bar'
import Footer from '@components/footer'
import OnlineStatus from "@components/global/OnlineStatus";
import SubscriptionExpiration from "@components/global/SubscriptionExpiration";
import SmsThresholdApproaching from "@components/global/SmsThresholdApproaching";
import MissingPhone from "@components/global/MissingPhone.vue";
import ProfileSidebar from "@views/user/ProfileSidebar";
import {mapState} from "vuex";

export default {
  components: { TopBar, Footer, OnlineStatus, SubscriptionExpiration, SmsThresholdApproaching, MissingPhone, ProfileSidebar },
  computed: {
    ...mapState({
      user: state => state.auth.currentUser
    }),
  },
  created() {
    document.body.classList.remove('authentication-bg');
    document.body.classList.remove('authentication-bg-pattern');
  },
}
</script>

<template>
  <div class="tw-flex tw-flex-col" style="min-height: 100vh;">
    <header id="topnav">
      <TopBar/>
    </header>

    <div class="wrapper">
      <div class="container-fluid">
        <sms-threshold-approaching />
        <subscription-expiration v-if="user" :key="user.subscriptionDue" />
        <missing-phone v-if="user" />

        <div class="account-shell">
          <ProfileSidebar />
          <div class="account-content">
            <slot />
          </div>
        </div>
      </div>
    </div>

    <Footer />
    <OnlineStatus/>
  </div>
</template>

<style lang="scss" scoped>
.account-shell {
  display: flex;
  gap: 2rem;
  padding-top: 1.25rem;

  @media (max-width: 991px) {
    flex-direction: column;
    gap: 1rem;
    padding-top: 1rem;
  }
}

.account-content {
  flex: 1;
  min-width: 0;
  padding-bottom: 3rem;

  @media (max-width: 991px) {
    padding-bottom: 2rem;
  }
}
</style>
